import * as React from 'react';
import BaseButton, { BaseButtonState } from '../common/BaseButton';
import { convertRGBAtoColorString } from '../../utils/ui';
import { sneCustomColors } from '../../drawing/constants';

interface SNEColorIconButtonProps {
  readonly onClick?: () => void;
  readonly colorIndex: number;
  readonly href?: string;
  readonly style?: React.CSSProperties;
  readonly title?: string;
  readonly ariaLabel?: string;
  readonly active?: boolean;
  readonly disabled?: boolean;
  readonly margin?: boolean;
}

const buttonBaseStyle: React.CSSProperties = {
  width: '30px',
  height: '30px',
};

const render =  (state: BaseButtonState, props: SNEColorIconButtonProps): JSX.Element => {
  const { disabled, style, colorIndex } = props;
  const buttonAdditionalStyle: React.CSSProperties = {};
  let stateKey = 'out';

  if (!disabled && state.hovered && !state.pressed) {
    stateKey = 'over';
  }

  if (state.pressed) {
    stateKey = 'selected';
  }

  const colors = sneCustomColors[stateKey];
  if (colors === undefined) {
    throw new Error('Undefined color.');
  }

  buttonAdditionalStyle.backgroundColor =
    convertRGBAtoColorString(colors[colorIndex]);

  return (
    <div style={{ ...buttonBaseStyle, ...buttonAdditionalStyle, ...style }} />
  );
};

const SNEColorButton: React.SFC<SNEColorIconButtonProps> = React.memo((props) => {
  const { onClick, href, title, ariaLabel, active, disabled } = props;

  return (
    <BaseButton
      render={state => render(state, props)}
      onClick={onClick}
      href={href}
      title={title}
      ariaLabel={ariaLabel}
      active={active}
      disabled={disabled} />
  );
});

export default SNEColorButton;
